/**
 * @generated SignedSource<<d4254da3877d0c57be180439df5300ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductAdminDashboardBlockFragment$data = {
  readonly id: string;
  readonly productId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardBlockAdminDropdownFragment" | "DashboardBlockItemTemplateFragment" | "ProductAdminInfoToolbarFragment">;
  readonly " $fragmentType": "ProductAdminDashboardBlockFragment";
};
export type ProductAdminDashboardBlockFragment$key = {
  readonly " $data"?: ProductAdminDashboardBlockFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductAdminDashboardBlockFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductAdminDashboardBlockFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "productId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardBlockAdminDropdownFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardBlockItemTemplateFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductAdminInfoToolbarFragment"
    }
  ],
  "type": "ProductAdminDashboardBlock",
  "abstractKey": null
};

(node as any).hash = "7e39d088fc127eccf136dbc177c4ed4e";

export default node;
